const customerService = {
  addEditIncident() {
    return `/customer-service/incident`;
  },
  closeIncident(incidentId) {
    return `/customer-service/incident/${incidentId}/close`;
  },
  deleteIncident(incidentId) {
    return `/customer-service/incident/${incidentId}`;
  },
  getCustomerServiceAssignToUsers() {
    return `/customer-service/users`;
  },
  assignIncidents() {
    return `/customer-service/incidents/assign`;
  },
  addAppraiserRejections(controlIdNumber) {
    return `/customer-service/incident/appraiser/${controlIdNumber}`;
  },
  getAppraiserRejections(controlIdNumber) {
    return `/customer-service/incident/appraiser/${controlIdNumber}`;
  }
};

export default customerService;